var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.file.thumb !== undefined &&
        (_vm.file.type === 'jpeg' ||
          _vm.file.type === 'JPEG' ||
          _vm.file.type === 'jpg' ||
          _vm.file.type === 'JPG' ||
          _vm.file.type === 'image/jpeg')
    )?_c('img',{staticClass:"upload-attachment__loading__file--icon",attrs:{"src":_vm.file.thumb}}):(
      _vm.file.thumb === undefined &&
        (_vm.file.type === 'jpeg' ||
          _vm.file.type === 'JPEG' ||
          _vm.file.type === 'jpg' ||
          _vm.file.type === 'JPG' ||
          _vm.file.type === 'image/jpeg')
    )?_c('img',{attrs:{"src":require("../../assets/images/icons/jpg.png")}}):(
      _vm.file.thumb !== undefined &&
        (_vm.file.type === 'png' ||
          _vm.file.type === 'PNG' ||
          _vm.file.type === 'image/png')
    )?_c('img',{staticClass:"upload-attachment__loading__file--icon",attrs:{"src":_vm.file.thumb}}):(
      _vm.file.thumb === undefined &&
        (_vm.file.type === 'png' ||
          _vm.file.type === 'PNG' ||
          _vm.file.type === 'image/png')
    )?_c('img',{attrs:{"src":require("../../assets/images/icons/png.svg")}}):(
      _vm.file.type === 'pdf' ||
        _vm.file.type === 'PDF' ||
        _vm.file.type === 'application/pdf'
    )?_c('img',{attrs:{"src":require("../../assets/images/icons/pdf.svg")}}):(
      _vm.file.type === 'csv' ||
        _vm.file.type === 'CSV' ||
        _vm.file.type === 'text/csv'
    )?_c('img',{attrs:{"src":require("../../assets/images/icons/csv.png")}}):(
      _vm.file.type === 'xlsx' ||
        _vm.file.type === 'XLSX' ||
        _vm.file.type === 'xls' ||
        _vm.file.type === 'XLS' ||
        _vm.file.type === 'application/vnd.ms-excel' ||
        _vm.file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    )?_c('img',{attrs:{"src":require("../../assets/images/icons/xls.svg")}}):(_vm.isOutlookMessage(_vm.file))?_c('img',{attrs:{"src":require("../../assets/images/icons/outlook.png")}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }